export const LUNCH = [
  {
    id: 1,
    time: "10-11 AM",
  },
  {
    id: 2,
    time: "11-12 AM",
  },
  {
    id: 3,
    time: "12-1 PM",
  },
  {
    id: 4,
    time: "1-2 PM",
  },
  {
    id: 5,
    time: "2-3 PM",
  },
];
export const DINNER = [
  {
    id: 1,
    time: "4-5 PM",
  },
  {
    id: 1,
    time: "5-6 PM",
  },
  {
    id: 2,
    time: "6-7 PM",
  },
  {
    id: 3,
    time: "7-8 PM",
  },
  {
    id: 4,
    time: "8-9 PM",
  },
  {
    id: 5,
    time: "9-10 PM",
  },
];
